import { Component, OnInit } from '@angular/core';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'transflo-scheduler-footer',
  templateUrl: './scheduler-footer.component.html',
  providers: [NgbModalConfig, NgbModal]
})
export class SchedulerFooterComponent implements OnInit {

  constructor(config: NgbModalConfig, private modalService: NgbModal) {
    config.backdrop = 'static';
  }

  ngOnInit(): void {
  }

  open(content: any): void {
    this.modalService.open(content, { centered: true, backdropClass: 'scheduler-modal' });
  }

  closeModal(shouldCloseModal: boolean): void {
    if (shouldCloseModal) {
      this.modalService.dismissAll();
    }
  }

}
